import React from 'react';
import classes from './Dropdown.css';

const dropdown = (props) => (
    <div className={classes.DropdownHolder} >
        <select className={classes.Dropdown} onChange={props.changed}> 
            {props.options.map(option => (
                <option key={option.value} value={option.value}>{option.placeholder}</option>
            ))}
        </select>
    </div>
)

export default dropdown;


// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js